import React, { useEffect, useState } from 'react';
import {
  Image,
  View,
  Text,
  TouchableOpacity,
  WithModalButton,
} from '../../app-components';
import {
  appraiseAllProfileIcon,
  changePasswordIcon,
  subscriptionHistoryLogo,
} from '../../images';
import { getUser, invoke } from '../../AppServices';
import { ROUTES } from '../../Lib/constants';
import { IconButton } from '../../app-components/buttons/Buttons';
import { getUserRole } from '../../Lib/helpers';

const renderModal = (props) => ({ frameStyle, hideModal }) => {
  const { expirationDate } = props;
  const user = getUser();
  const userRole = getUserRole();
  const customUserInfoWrapper = {
    width: 70,
    height: 70,
    borderRadius: 50,
    borderWidth: 2,
    borderColor: '#010101',
    backgroundColor: 'rgba(1, 1, 1, 0.1)',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  };
  const customUsernameText = {
    textTransform: 'uppercase',
    color: '#010101',
    fontSize: '30px',
  };

  return (
    <TouchableOpacity
      onPress={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      style={{
        ...frameStyle,
        right: '20px',
        top: '60px',
        // height: '40%',
        overflow: 'auto',
        borderRadius: '10px',
        // border: '1px solid red',
        height: 'auto',
      }}
    >
      <View style={{ flex: 1, backgroundColor: 'white' }}>
        <View
          style={{
            display: 'flex',
            flexDirection: 'column',
            marginTop: 16,
            fontSize: 16,
            gap: 32,
          }}
        >
          <View
            style={{
              flexDirection: 'column',
              alignItems: 'center',
              gap: 18,
            }}
          >
            <View style={customUserInfoWrapper}>
              <Text style={customUsernameText}>
                {user.username.charAt(0)}
              </Text>
            </View>
            <View style={{ alignItems: 'center', gap: 8 }}>
              <Text
                style={{
                  fontFamily: 'Montserrat',
                  fontSize: '18px',
                }}
              >
                {user.username}
              </Text>

              {user.email === 'superadmin' ? null : (
                <Text
                  style={{
                    fontFamily: 'Montserrat',
                    fontSize: '16px',
                    color: '#79798B',
                  }}
                >
                  {user.email}
                </Text>
              )}

              {(userRole === 'dealer' || userRole === 'superdealer') && expirationDate !== '' ? (
                <Text
                  style={{
                    fontFamily: 'Montserrat',
                    fontSize: '16px',
                    color: '#79798B',
                  }}
                >
                  {expirationDate}
                </Text>
              ) : null}
            </View>
          </View>

          <View style={{ border: '1px solid #DCDCDC' }} />

          {/* this is for change password section */}
          {userRole === 'superadmin' ? (
            <>
              {/* for password change */}
              <TouchableOpacity
                onPress={() => {
                  const { navigation } = props;
                  navigation.navigate({
                    view: ROUTES.passwordSA.name,
                    modal: true,
                    modalProps: { backgroundColor: 'transparent' },
                  });
                }}
                style={{
                  flexDirection: 'row',
                  gap: 10,
                  paddingLeft: 20,
                  cursor: 'pointer',
                  marginTop: -20,
                }}
              >
                <Image
                  source={changePasswordIcon}
                  style={{ width: 20, height: 20 }}
                />
                <View style={{}}>
                  <Text
                    style={{ fontFamily: 'Montserrat', color: '#605BFF' }}
                  >
                    Change Password
                  </Text>
                </View>
              </TouchableOpacity>
            </>
          ) : null}

          {/* this is for subscripiton history button  */}
          {userRole === 'superadmin' || userRole === 'admin' ? (
            <TouchableOpacity
              onPress={() => {
                const { navigation } = props;
                navigation.reset(ROUTES.subscriptionHistoryListAll.name);
                hideModal();
              }}
              style={{
                flexDirection: 'row',
                gap: 10,
                paddingLeft: 20,
                cursor: 'pointer',
                marginBottom: 10,
                marginTop: -20,
              }}
            >
              <Image
                source={subscriptionHistoryLogo}
                style={{ width: 22, height: 22 }}
              />
              <View style={{}}>
                <Text
                  style={{
                    fontFamily: 'Montserrat',
                    color: '#605BFF',
                  }}
                >
                  Subscription History
                </Text>
              </View>
            </TouchableOpacity>
          ) : null}
        </View>
      </View>
    </TouchableOpacity>
  );
};

const UserInfo = (props) => {
  const [expirationDate, setExpirationDate] = useState('');
  const getExpirationDate = async () => {
    const { result } = await invoke({
      id: 'getDealerSubscriptionExpiringDate',
      paramValue: {},
    });
    setExpirationDate(result.endDate);
  };

  useEffect(() => {
    getExpirationDate();
  }, []);

  return (
    <WithModalButton
      renderModal={renderModal({ ...props, expirationDate })}
      autoHide
      backdropStyle={{
        backgroundColor: 'rgba(0, 0, 0, .30)',
        overflow: 'hidden',
        top: 0,
      }}
      style={{ marginRight: '2%' }}
      dropdownStyle={{
        width: 350,
        height: '100%',
        overflow: 'hidden',
      }}
    >
      <IconButton
        tooltipId="account-info"
        description="Account Info"
        icon={appraiseAllProfileIcon}
        label="Change Password"
        labelStyle={{
          fontSize: 18,
          color: '#ffffff',
          fontFamily: 'Mulish-SemiBold',
        }}
      />
    </WithModalButton>
  );
};

export default UserInfo;
